<!-- <div class="loader" *ngIf="showLoader"></div> -->
<div class="loader-container" *ngIf="showLoader || onDemandLoader">
  <div id="loadingGIF" class="loader"></div>
</div>
<!-- <div class="overlay" *ngIf="showLoader"></div> -->
<app-header *ngIf="showHeader"></app-header>
<router-outlet></router-outlet>
